import { create } from "zustand";
import { persist } from "zustand/middleware";

interface HubUpdatesStore {
  isOpen: boolean;
  latestSeenUpdateDate: string | null;
  setIsOpen: (open: boolean) => void;
  handleOpen: () => void;
  handleClose: () => void;
  markLatestUpdateAsSeen: (publishedAt: string) => void;
  hasSeenUpdate: (publishedAt: string) => boolean;
  setLatestSeenForNewUser: (publishedAt: string) => void;
}

export const useHubUpdatesStore = create<HubUpdatesStore>()(
  persist(
    (set, get) => ({
      isOpen: false,
      latestSeenUpdateDate: null,

      setIsOpen: (open) => set({ isOpen: open }),

      handleOpen: () => set({ isOpen: true }),

      handleClose: () => set({ isOpen: false }),

      markLatestUpdateAsSeen: (publishedAt) => {
        const { latestSeenUpdateDate } = get();
        // Only update if this date is more recent than what we've seen
        if (!latestSeenUpdateDate || new Date(publishedAt) > new Date(latestSeenUpdateDate)) {
          set({ latestSeenUpdateDate: publishedAt });
        }
      },

      hasSeenUpdate: (publishedAt) => {
        const { latestSeenUpdateDate } = get();
        return latestSeenUpdateDate !== null && new Date(publishedAt) <= new Date(latestSeenUpdateDate);
      },

      setLatestSeenForNewUser: (publishedAt) => {
        const { latestSeenUpdateDate } = get();
        // Only set if no previous record exists (new user)
        if (latestSeenUpdateDate === null) {
          set({ latestSeenUpdateDate: publishedAt });
        }
      },
    }),
    {
      name: "hub-updates-storage",
      partialize: (state) => ({
        latestSeenUpdateDate: state.latestSeenUpdateDate,
      }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<Pick<HubUpdatesStore, "latestSeenUpdateDate">> | null;

        if (persisted?.latestSeenUpdateDate && typeof persisted.latestSeenUpdateDate === "string") {
          return {
            ...currentState,
            latestSeenUpdateDate: persisted.latestSeenUpdateDate,
          };
        }
        return currentState;
      },
    },
  ),
);
